import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "checkbox"
  ]

  static values = {
    passedDueDate: Boolean
  }

  updateDueDateGroupClass () {
    const allChecked = this.checkboxTargets.every(checkbox => checkbox.checked)
    if (allChecked) {
      this.element.classList.remove('due-date-group--warning')
      this.element.classList.add('due-date-group--success')
    } else if (this.passedDueDateValue) {
      this.element.classList.remove('due-date-group--success')
      this.element.classList.add('due-date-group--warning')
    }
  }
}
